
import { useBranding } from '@/hooks/useBranding';
import { useMasterLicenseSettings } from '@/contexts/MasterLicenseSettingsContext';

const DEFAULT_LOGO_URL = '/assets/referme-logo.png';

const resolveLogoUrl = (url?: string | null) => {
  if (!url) return null;

  // Earlier generated CDN asset URLs are no longer reliable in the published app.
  if (url.includes('/__l5e/assets-v1/')) {
    return DEFAULT_LOGO_URL;
  }

  return url;
};

export const useLogoUrl = () => {
  const { logo } = useBranding();
  const uploadedLogoUrl = resolveLogoUrl(logo?.file_url);

  try {
    const { licenseSettings } = useMasterLicenseSettings();
    return uploadedLogoUrl || resolveLogoUrl(licenseSettings.logoUrl) || DEFAULT_LOGO_URL;
  } catch (error) {
    return uploadedLogoUrl || DEFAULT_LOGO_URL;
  }
};
